module.exports = __webpack_public_path__ + "static/media/arrow-alt-circle-down.670e2166.svg";